import styled from "styled-components";

export const LinkExpiredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
  padding: 2rem 1rem;
  background-color: ${({ theme }) => theme.colors["black-800"]};
`;

export const LinkExpiredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
`;

export const LinkExpiredTitle = styled.p`
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors["white"]};
  font-weight: 600;
`;

export const LinkExpiredDescription = styled.p`
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors["white"]};
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: start;
  gap: 1.5rem;

  h4 {
    color: ${({ theme }) => theme.colors["white"]};
  }
`;
